import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useState } from "react";
import { ErpDataDto } from "../../../types/dto/erp-data-dto";
import { CustomCell } from "../CustomCell";
import { ItemCodeTableFooter } from "./ItemCodeTableFooter";
import { ItemCodeTableRow } from "./ItemCodeTableRow";

interface Props {
  itemPage: BasePageDto<ErpDataDto>;
  erpCode: string;
  setErpCode: (erpCode: string) => void;
  handlePageChange: (currentPage: number) => void;
  closeModal: () => void;
}

const headers: TableHeader[] = [
  { title: "", width: "w-[52px]", align: "flex justify-center" },
  { title: "상품명", width: "w-[444px]" },
  { title: "모델명", width: "w-[160px]" },
  { title: "코드명", width: "w-[160px]" },
];
export const ItemCodeTable: React.FC<Props> = ({
  itemPage,
  erpCode,
  setErpCode,
  handlePageChange,
  closeModal,
}) => {
  const items = itemPage.contents;
  const totalElements = itemPage.totalElements;
  const currentPage = itemPage.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_12;
  const [selectedErpCode, setSelectedErpCode] = useState<string>(erpCode);

  const handleSelectErpCode = (erpCode: string) => {
    setSelectedErpCode(erpCode);
  };

  return (
    <div className="overflow-x-auto rounded-lg border">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>

        <Table.Body className="divide-y min-h-[329px]">
          {items.map((item, index) => (
            <ItemCodeTableRow
              key={index}
              data={item}
              selectedErpCode={selectedErpCode}
              handleSelectErpCode={handleSelectErpCode}
            />
          ))}
          <ItemCodeTableFooter
            headersLength={Object.values(headers).length}
            itemPage={itemPage}
            handlePageChange={handlePageChange}
            setErpCode={() => {
              setErpCode(selectedErpCode);
              closeModal();
            }}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
